import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
        <div>
            <header className="w3-container">
                <h5><b> My Dashboard</b></h5>
            </header>
            <div className="w3-row-padding w3-margin-bottom">
                <div className="w3-quarter">
                    <div className="w3-container w3-red w3-padding-16">
                        <div className="w3-left"><i className="far fa-envelope w3-xxxlarge"></i></div>
                        <div className="w3-right">
                            <h3></h3>
                        </div>
                        <div className="w3-clear"></div>
                        <h4>Mensajes</h4>
                    </div>
                </div>
                <div className="w3-quarter">
                    <div className="w3-container w3-blue w3-padding-16">
                        <div className="w3-left"><i className="fas fa-shopping-cart w3-xxxlarge"></i></div>
                        <div className="w3-right">
                            <h3></h3>
                        </div>
                        <div className="w3-clear"></div>
                        <h4>Pedidos</h4>
                    </div>
                </div>
                <div className="w3-quarter">
                    <div className="w3-container w3-teal w3-padding-16">
                        <div className="w3-left"><i className="fas fa-users w3-xxxlarge"></i></div>
                        <div className="w3-right">
                            <h3></h3>
                        </div>
                        <div className="w3-clear"></div>
                        <h4>Clientes</h4>
                    </div>
                </div>
                <div className="w3-quarter">
                    <div className="w3-container w3-orange w3-text-white w3-padding-16">
                        <div className="w3-left"><i className="fas fa-bullseye w3-xxxlarge"></i></div>
                        <div className="w3-right">
                            <h3></h3>
                        </div>
                        <div className="w3-clear"></div>
                        <h4>Productos</h4>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home/Home.js